<div style="display:flex; flex-direction:row; flex-grow:1; overflow:hidden;height:100%;">
    <div style="display:flex; flex-direction:column; flex:1; overflow:hidden;height:100%">
        <tyl-kendo-pdf-export [keepTogether]="'.mat-row'" class="tylKendoPdf" [scale]="0.40">
            <!-- Header -->
            <page-header *ngIf="!filteringStudents" class="flex-header"></page-header>

            <!-- <student-header [pageTitle]="'Student Notes'" [showYearSelector]="false" *ngIf="filteringStudents"
            [useStudents]="studentFilters" (studentChange)="studentChange($event)" class="flex-header"></student-header> -->
            <student-header [pageTitle]="'Student Notes'" [showYearSelector]="false" *ngIf="filteringStudents"
                            (studentChange)="studentChange($event)" class="flex-header"></student-header>

            <!-- Content -->
            <form class="flex-content" style="overflow: auto" #formRef="ngForm" id="studentNotesForm">

                <!-- No Data Warning -->
                <div *ngIf="studentNotes && studentNotes.length == 0" style="text-align: center">
                    No Student Notes data for this year.
                </div>

                <!-- Notes Table -->
                <mat-table [dataSource]="tableData" *ngIf="studentNotes && studentNotes.length > 0" [ngStyle]="{
            'min-width': minTableWidth + 'px'
        }" matSort matSortDisableClear matSortActive="student" matSortDirection="asc" multiTemplateDataRows>

                    <!-- More Column -->
                    <ng-container matColumnDef="more">
                        <mat-header-cell *matHeaderCellDef translate>
                            More
                        </mat-header-cell>
                        <mat-cell *matCellDef="let note">
                            <span (click)="tableData.toggleExpanded(note); $event.stopPropagation();" [ngClass]="{
                        'detail-row-expanded-icon': tableData.checkExpanded(note),
                        'detail-row-collapsed-icon': !tableData.checkExpanded(note)
                    }"></span>
                        </mat-cell>
                    </ng-container>

                    <!-- Student Column -->
                    <ng-container matColumnDef="student">
                        <mat-header-cell *matHeaderCellDef mat-sort-header="student" translate>
                            Student
                            <filter [data]="tableData" columnName="student" dataType="string" id="studentFilter"
                                    class="mat-filter"></filter>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let note">
                            <a (click)="viewStudent(note); $event.stopPropagation();">
                                <student-name [firstName]="note.FirstName" [lastName]="note.LastName"
                                              [middleName]="note.MiddleName" [nickName]="note.Nickname"></student-name>
                            </a>
                        </mat-cell>
                    </ng-container>

                    <!-- Student Number -->
                    <ng-container matColumnDef="studentNumber">
                        <mat-header-cell *matHeaderCellDef mat-sort-header="studentNumber" translate>
                            Student
                            <filter [data]="tableData" columnName="studentNumber" dataType="string" id="studentFilter"
                                    class="mat-filter"></filter>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let note">
                            #{{note.StudentNumber}}
                        </mat-cell>
                    </ng-container>

                    <!-- Category Column -->
                    <ng-container matColumnDef="category">
                        <mat-header-cell *matHeaderCellDef mat-sort-header="category" translate>
                            Category
                            <filter [data]="tableData" columnName="category" dataType="string" id="categoryFilter"
                                    class="mat-filter"></filter>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let note; let i = dataIndex"
                                  [ngClass]="{'errorState': !note.SNCID && selectedRow != note}"
                                  (click)="cellClick(note, 'category')">

                            <!-- Edit Category -->
                            <ng-container *ngIf="userCanEditNotes && selectedRow == note">
                                <tyl-form-field>
                                    <mat-select [(ngModel)]="note.SNCID" #categoryField name="category{{i}}"
                                                id="category{{i}}" [required]="true">
                                        <mat-option *ngFor="let category of categories" [value]="category.Id">
                                            {{category.Code}}
                                        </mat-option>
                                    </mat-select>
                                </tyl-form-field>
                            </ng-container>

                            <!-- View Category -->
                            <ng-container *ngIf="!userCanEditNotes || selectedRow != note">
                                {{note.category(categories) ? note.category(categories).Code : ''}}
                            </ng-container>
                        </mat-cell>
                    </ng-container>

                    <!-- Note Column -->
                    <ng-container matColumnDef="note">
                        <mat-header-cell *matHeaderCellDef mat-sort-header="Note" translate>
                            Note
                            <filter [data]="tableData" columnName="Note" dataType="string" id="noteFilter"
                                    class="mat-filter"></filter>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let note; let i = dataIndex;"
                                  [ngClass]="{'errorState': !note.Note && selectedRow != note}" (click)="cellClick(note, 'note')">

                            <!-- Edit Note -->
                            <ng-container *ngIf="userCanEditNotes && selectedRow == note">
                                <tyl-form-field style="width: 100%">
                                    <input matInput #noteField name="note{{i}}" id="note{{i}}" title="Note"
                                           [(ngModel)]="note.Note" rows="3" maxlength="1000" required />
                                    <mat-hint>
                                        {{note.Note ? 1000 - note.Note.length : 1000}} characters left
                                    </mat-hint>
                                </tyl-form-field>
                            </ng-container>

                            <!-- View Note -->
                            <ng-container *ngIf="!userCanEditNotes || selectedRow != note">
                                <span class="note">
                                    {{note.Note}}
                                </span>
                            </ng-container>
                        </mat-cell>
                    </ng-container>

                    <!-- Order Column -->
                    <ng-container matColumnDef="order">
                        <mat-header-cell *matHeaderCellDef mat-sort-header="Order" translate>
                            Order
                            <filter [data]="tableData" columnName="Order" dataType="number" id="orderFilter"
                                    class="mat-filter"></filter>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let note; let i = dataIndex;"
                                  [ngClass]="{'errorState': (note.Order == undefined || note.Order == '') && selectedRow != note}"
                                  (click)="cellClick(note, 'order')">

                            <!-- Edit Order -->
                            <ng-container *ngIf="userCanEditNotes && selectedRow == note">
                                <tyl-form-field>
                                    <input matInput #orderField name="order{{i}}" id="order{{i}}" title="Order"
                                           [(ngModel)]="note.Order" numbers-only required />
                                </tyl-form-field>
                            </ng-container>

                            <!-- View Order -->
                            <ng-container *ngIf="!userCanEditNotes || selectedRow != note">
                                {{note.Order}}
                            </ng-container>
                        </mat-cell>
                    </ng-container>

                    <!-- Status Column -->
                    <ng-container matColumnDef="status">
                        <mat-header-cell *matHeaderCellDef mat-sort-header="Status" translate>
                            Status
                            <filter [data]="tableData" columnName="Status" dataType="boolean" trueValue="Active"
                                    falseValue="Inactive" showTrueLabel="Show active" showFalseLabel="Show inactive"
                                    class="mat-filter"
                                    (filterChange)="headerFilterChanged('Status')"
                                    ></filter>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let note; let i = dataIndex;"
                                  [ngClass]="{'errorState': !note.Status && selectedRow != note}"
                                  (click)="cellClick(note, 'status')">

                            <!-- Edit Status -->
                            <ng-container *ngIf="userCanEditNotes && selectedRow == note">
                                <tyl-form-field>
                                    <mat-select [(ngModel)]="note.Status" name="status{{i}}" id="status{{i}}" #statusField
                                                [required]="true">
                                        <mat-option value="Active">
                                            Active
                                        </mat-option>
                                        <mat-option value="Inactive">
                                            Inactive
                                        </mat-option>
                                    </mat-select>
                                </tyl-form-field>
                            </ng-container>

                            <!-- View Status -->
                            <ng-container *ngIf="!userCanEditNotes || selectedRow != note">
                                {{note.Status}}
                            </ng-container>
                        </mat-cell>
                    </ng-container>

                    <!-- Start Date Column -->
                    <ng-container matColumnDef="start-date">
                        <mat-header-cell *matHeaderCellDef mat-sort-header="StartDate" translate>
                            Start Date
                            <filter [data]="tableData" columnName="StartDate" dataType="date" id="startDateFilter"
                                    class="mat-filter"></filter>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let note; let i = dataIndex;" (click)="cellClick(note, 'startDate')">

                            <!-- Edit Start Date -->
                            <ng-container *ngIf="userCanEditNotes && selectedRow == note">
                                <tyl-datepicker [(value)]="note.StartDate" id="startDate{{i}}" #startDateField>
                                </tyl-datepicker>
                            </ng-container>

                            <!-- View Start Date -->
                            <ng-container *ngIf="!userCanEditNotes || selectedRow != note">
                                {{note.StartDate | date: 'MM/dd/yy'}}
                            </ng-container>
                        </mat-cell>
                    </ng-container>

                    <!-- End Date Column -->
                    <ng-container matColumnDef="end-date">
                        <mat-header-cell *matHeaderCellDef mat-sort-header="EndDate" translate>
                            End Date
                            <filter [data]="tableData" columnName="EndDate" dataType="date" id="endDateFilter"
                                    class="mat-filter"></filter>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let note; let i = dataIndex;" (click)="cellClick(note, 'endDate')">

                            <!-- Edit End Date -->
                            <ng-container *ngIf="userCanEditNotes && selectedRow == note">
                                <tyl-datepicker [(value)]="note.EndDate" #endDateField id="endDate{{i}}"></tyl-datepicker>
                            </ng-container>

                            <!-- View End Date -->
                            <ng-container *ngIf="!userCanEditNotes || selectedRow != note">
                                {{note.EndDate | date: 'MM/dd/yy'}}
                            </ng-container>
                        </mat-cell>
                    </ng-container>

                    <!-- Display as Bold Column -->
                    <ng-container matColumnDef="display-as-bold">
                        <mat-header-cell *matHeaderCellDef mat-sort-header="display-as-bold" translate>
                            Display <br /> as Bold
                            <filter [data]="tableData" columnName="DisplayBold" dataType="boolean" trueValue="true"
                                    falseValue="false" showTrueLabel="Shows as bold" showFalseLabel="Does not show as bold"
                                    dataType="boolean" id="displayBoldFilter" class="mat-filter"></filter>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let note; let i = dataIndex;" (click)="cellClick(note, 'displayAsBold')">

                            <!-- Edit Display as Bold -->
                            <ng-container *ngIf="userCanEditNotes && selectedRow == note">
                                <tyl-checkbox [(checked)]="note.DisplayBold" #displayBoldCheckbox name="displayAsBold{{i}}"
                                              id="displayAsBold{{i}}" (click)="$event.stopPropagation()"></tyl-checkbox>
                            </ng-container>

                            <!-- View Display as Bold -->
                            <ng-container *ngIf="!userCanEditNotes || selectedRow != note">
                                {{note.DisplayBold ? 'Y' : ''}}
                            </ng-container>
                        </mat-cell>
                    </ng-container>

                    <!-- Classroom Note Column -->
                    <ng-container matColumnDef="classroom-note">
                        <mat-header-cell *matHeaderCellDef mat-sort-header="classroom-note" translate>
                            Classroom <br /> Note
                            <filter [data]="tableData" columnName="ClassroomNote" dataType="boolean" trueValue="true"
                                    falseValue="false" showTrueLabel="Is classroom note" showFalseLabel="Is not classroom note"
                                    dataType="boolean" id="displayBoldFilter" class="mat-filter"></filter>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let note; let i = dataIndex;" (click)="cellClick(note, 'classroomNote')">

                            <!-- Edit Display as Bold -->
                            <ng-container *ngIf="userCanEditNotes && selectedRow == note">
                                <tyl-checkbox [(checked)]="note.ClassroomNote" #classroomNoteCheckbox
                                              name="classroomNote{{i}}" id="classroomNote{{i}}" (click)="$event.stopPropagation()">
                                </tyl-checkbox>
                            </ng-container>

                            <!-- View Display as Bold -->
                            <ng-container *ngIf="!userCanEditNotes || selectedRow != note">
                                {{note.ClassroomNote ? 'Y' : ''}}
                            </ng-container>
                        </mat-cell>
                    </ng-container>

                    <!-- Actions Column (EDIT ONLY) -->
                    <ng-container matColumnDef="actions">
                        <mat-header-cell *matHeaderCellDef translate>
                            Actions
                        </mat-header-cell>
                        <mat-cell *matCellDef="let note; let i = dataIndex;">
                            <tyl-mat-menu image="actions.png" [showLabel]="false" [topMenuItems]="['Edit']"
                                          [bottomMenuItems]="['Delete']"
                                          (menuClick)="$event.itemName == 'Edit' ? editNote(note) : deleteNote(note)"></tyl-mat-menu>
                        </mat-cell>
                    </ng-container>

                    <!-- Expand Row -->
                    <ng-container matColumnDef="expandRow">
                        <td mat-cell *matCellDef="let note" class="mat-detail-card" [colSpan]="columns.length">
                            <table style="width:100%;">
                                <tr>
                                    <td class="detailLabel">Created By</td>
                                    <td style="width:40%;">{{note.AddedBy ? note.AddedBy : '&nbsp;'}}</td>
                                    <td class="detailLabel">Last Edited By</td>
                                    <td style="width:40%;">{{note.LastUpBy ? note.LastUpBy : '&nbsp;'}}</td>
                                </tr>
                                <tr>
                                    <td class="detailLabel">Created On</td>
                                    <td>{{note.AddedOn ? (note.AddedOn | date:'MM/dd/yy') : '&nbsp;'}}</td>
                                    <td class="detailLabel">Last Edited On</td>
                                    <td>{{note.LastUpOn ? (note.LastUpOn | date:'MM/dd/yy') : '&nbsp;'}}</td>
                                </tr>
                                <tr>
                                    <!-- This is just for spacing -->
                                    <td colspan="4">&nbsp;</td>
                                </tr>
                                <tr>
                                    <td class="detailLabel">Note</td>
                                    <td colspan="3">{{note.Note}}</td>
                                </tr>
                            </table>
                        </td>
                    </ng-container>

                    <!-- Row Definitions -->
                    <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: columns; let i = dataIndex;" matRipple tabindex="0"
                             style="cursor: pointer" [ngClass]="{
                'detailRowOpened': tableData.checkExpanded(row),
                'selectedRow': selectedRow == row
            }" id="row{{i}}"></mat-row>
                    <mat-row *matRowDef="let row; columns: ['expandRow']" (click)="selectedRow = row;"
                             class="mat-detail-row" [ngClass]="{'selectedRow': selectedRow == row}"
                             [@detailExpand]="tableData.checkExpanded(row) ? 'expanded' : 'collapsed'" style="overflow: hidden">
                    </mat-row>
                </mat-table>
            </form>
        </tyl-kendo-pdf-export>
        <mat-paginator [pageSizeOptions]="[100, 250, 500]" showFirstLastButtons></mat-paginator>

        <!-- Footer -->
        <div class="flex-footer">

            <!-- Left Buttons -->
            <expand-collapse-buttons [expandEmitter]="toggleExpandRows"></expand-collapse-buttons>
            <tyl-button *ngIf="userCanEditNotes" image="Add.png" label="Add Note" (clickEvent)="addNote()"></tyl-button>
            <tyl-button *ngIf="userCanEditNotes" label="Mass Add" image="multi add no circle.png"
                        (clickEvent)="massAdd()"></tyl-button>
            <tyl-button [image]="filtering ? 'filter yellow.png' : 'filter.png'" label="Filter"
                        (clickEvent)="showFilterClick()"></tyl-button>

            <!-- Middle Area -->
            <div class="footerCenter" style="align-items: center">
                <filter-notification [filtered]="filtering || tableData.isFiltered()" (filter)="showFilterClick()"
                                     (clearFilter)="clearFilterFromFooter()"></filter-notification>
            </div>

            <!-- Right Buttons -->
            <div class="footerRight">
                <ng-container *ngIf="selectedRow">
                    <error-prompt [errorList]="errors"></error-prompt>
                    <tyl-button image="save.png" label="Save" (clickEvent)="saveClick(); validationTrigger.click();">
                    </tyl-button>
                </ng-container>
            </div>
        </div>

        <!-- Form Validation Trigger -->
        <input style="display: none" type="submit" form="studentNotesForm" #validationTrigger>

    </div>


    <div *ngIf="showFilter" class="filter-body">
        <!-- Filter -->
        <div class="flex-header sis-app-header-label" style="font-weight:bold; font-size:20px;" translate>
            Filter
        </div>

        <div class="flex-content">

            <!-- Student Number -->
            <label>Student #</label>
            <tyl-form-field>
                <input matInput name="studentNumber" id="filterStudentNumberField" [ngModel]="filter.studentNumber"
                       (ngModelChange)="filter.studentNumber = $event; arrangeTableData();" numbers-only>
            </tyl-form-field>

            <!-- Student Filter -->
            <label>Student</label>
            <div style="display: flex; justify-content: space-between;">
                <button mat-button (click)="studentSearchFilter()" translate>
                    Search and Select
                </button>
                <button mat-button (click)="clearStudentSearchFilter()" translate>
                    Clear Student Filter
                </button>
            </div>

            <!-- Category Filter -->
            <label>Category</label>
            <tyl-form-field>
                <input matInput name="category" id="filterCategoryField" [ngModel]="filter.category"
                       (ngModelChange)="filter.category = $event; arrangeTableData();">
            </tyl-form-field>

            <!-- Note Filter -->
            <label>Note</label>
            <tyl-form-field>
                <input matInput name="note" id="filterNoteField" [ngModel]="filter.note"
                       (ngModelChange)="filter.note = $event; arrangeTableData();">
            </tyl-form-field>

            <!-- Status Filter -->
            <label>Status</label>
            <tyl-form-field>
                <input matInput name="status" id="filterStatusField" [ngModel]="filter.status"
                       (ngModelChange)="filter.status = $event; arrangeTableData();">
            </tyl-form-field>

            <!-- Start Date Filter -->
            <label>Start Date</label>
            <tyl-datepicker [value]="filter.startDateFrom"
                            (valueChange)="filter.startDateFrom = $event; arrangeTableData();" label="From"
                            id="filterStartDateFromField"></tyl-datepicker>
            <tyl-datepicker [value]="filter.startDateTo"
                            (valueChange)="filter.startDateTo = $event; arrangeTableData();" label="To" id="filterStartDateToField">
            </tyl-datepicker>

            <!-- End Date Filter -->
            <label>End Date</label>
            <tyl-datepicker [value]="filter.endDateFrom"
                            (valueChange)="filter.endDateFrom = $event; arrangeTableData();" label="From"
                            id="filterEndDateFromField"></tyl-datepicker>
            <tyl-datepicker [value]="filter.endDateTo" (valueChange)="filter.endDateTo = $event; arrangeTableData();"
                            label="To" id="filterEndDateToField"></tyl-datepicker>
        </div>

        <div class="filter-flex-footer">

            <!-- Left Buttons -->
            <tyl-button image="startover.png" label="Clear" (clickEvent)="clearFilter()"></tyl-button>

            <!-- Right Buttons -->
            <div class="footerRight">
                <tyl-button image="Cancel.png" label="Close" (clickEvent)="cancelFilter()"></tyl-button>
            </div>
        </div>
    </div>

</div>
